import { Column } from "../objects/column";
import { Cms } from "../objects/cms";
import { CmsListConfiguration, CmsListFiltersCriteria, CmsListCriteria  } from "../objects/cmsList";
import { FunnelDeposit } from "../objects/funnel";
import { FlightAndHotelParameter } from "../objects/flightAndHotelParameter";

export const EMPTY_FUNNEL_DEPOSIT: FunnelDeposit = {
    nb_days_before_trip_start_date: "",
    deposit: "",
    type: "FIX"
};

export const EMPTY_FLIGHT_AND_HOTEL_PARAMETER: FlightAndHotelParameter = {
    id: 0,
    flight_be_selected_first: false,
    sell_products: [],
    show_flight_timer: false,
    allow_multiple_hotels: false,
};

export const EMPTY_CMS: Cms = {
    id: 0,
    name: '',
    domain: '',
    is_active: false,
    created_date: new Date(),
    modified_date: new Date(),
    creator: null,
    last_author: null,
    is_secondary: false,
    authentication_required: false,
    authentication_required_to_book: false,
    authentication_required_to_create_trip: false,
    allow_all_destinations: true,
    localization: [],
    deactivation_message: '',
    contact_email: null,
    logo: null,
    allow_all_hotels: false,
    selling_currencies: [],
    is_b2c: false,
    email_2fa_enabled: false,
    allow_all_circuits: false,
    allow_all_custom_products: false,
    allow_all_transfers: false
};

export const EMPTY_CMS_FILTERS: CmsListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};

export const EMPTY_CMS_LIST_CRITERIA: CmsListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_CMS_FILTERS,
    search: '',
};

export const CMS_INFO_ROUTE = '/cms/edit/:id/info';
export const CMS_CONTACT_ROUTE = '/cms/edit/:id/contact';

export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'domain',
    field_name: 'DOMAIN',
    checked: true,
    order_by: 'domain',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'is-active',
    field_name: 'IS_ACTIVE',
    checked: true,
    order_by: 'is_active',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_CMS_LIST_CONFIGURATION: CmsListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const CMS_MODULE = 'CMS';
